import { Guid } from "@/types"
import { AssetOrigin } from "./Asset"

export interface ITaxBasedDeductionDto {
    id: Guid
    year: number
    percentageIFRS: number
    percentageLocal: number
}

export interface ICreateTaxBasedDeductionDto {
    assetOrigin: AssetOrigin
    year: number
    percentageIFRS: number
    percentageLocal: number
}

export class TaxBasedDeduction {
    id: Guid
    year: number
    percentageIFRS: number
    percentageLocal: number

    constructor(dto: ITaxBasedDeductionDto) {
        this.id = dto.id
        this.year = dto.year
        this.percentageIFRS = dto.percentageIFRS
        this.percentageLocal = dto.percentageLocal
    }
}
